var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrayChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4942 11.8973C16.4571 11.7637 16.5388 11.5781 16.6167 11.4445C16.6405 11.4048 16.6665 11.3664 16.6946 11.3295C17.3612 10.339 17.7178 9.17243 17.7188 7.97852C17.73 4.55703 14.8429 1.78125 11.2729 1.78125C8.15947 1.78125 5.56182 3.9002 4.95322 6.71309C4.86218 7.13 4.81615 7.55549 4.81592 7.98223C4.81592 11.4074 7.5917 14.2574 11.1616 14.2574C11.7294 14.2574 12.4938 14.0867 12.9132 13.9717C13.3325 13.8566 13.7481 13.7045 13.8558 13.6637C13.9661 13.6221 14.083 13.6007 14.2009 13.6006C14.3295 13.6001 14.4569 13.6253 14.5757 13.6748L16.6798 14.4207C16.7259 14.4402 16.7747 14.4527 16.8245 14.4578C16.9032 14.4578 16.9788 14.4265 17.0344 14.3709C17.0901 14.3152 17.1214 14.2397 17.1214 14.1609C17.1188 14.127 17.1126 14.0934 17.1028 14.0607L16.4942 11.8973Z",
    stroke: "#6D7B75",
    strokeWidth: 1.19792,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96631 8.60938C2.4796 9.48376 2.24415 10.4757 2.286 11.4756C2.32785 12.4754 2.64536 13.4442 3.20344 14.2749C3.28916 14.4044 3.33741 14.5046 3.32256 14.5717C3.30772 14.6389 2.87985 16.8677 2.87985 16.8677C2.86956 16.9199 2.87346 16.9738 2.89115 17.024C2.90884 17.0741 2.93967 17.1185 2.98041 17.1527C3.03478 17.196 3.10238 17.2193 3.1719 17.2188C3.20904 17.2189 3.24581 17.2113 3.27989 17.1965L5.3658 16.3801C5.50937 16.3235 5.66952 16.3262 5.81112 16.3875C6.51397 16.6614 7.29104 16.8328 8.06848 16.8328C9.11172 16.8339 10.1367 16.5588 11.0391 16.0353",
    stroke: "#6D7B75",
    strokeWidth: 1.19792,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayChat);
export default __webpack_public_path__ + "static/media/grayChat.7a0011d80a636a30ae343314a555dcc3.svg";
export { ForwardRef as ReactComponent };